import * as firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyDCKQa7L7HArtFbJYqyxq2jkUzKXv4KbDY',
  authDomain: 'bridegenie-3a910.firebaseapp.com',
  databaseURL: 'https://bridegenie-3a910.firebaseio.com',
  projectId: 'bridegenie-3a910',
  storageBucket: 'bridegenie-3a910.appspot.com',
  messagingSenderId: '994833569015',
  appId: '1:994833569015:web:9dc4650c9b14d770052ff2',
  measurementId: 'G-GKLCS4RZCS'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)

firebase.firestore()

export const db = firebaseApp.firestore()